// Class: starling.filters.CompositeEffect

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_rendering_FilterEffect() {return require("./../../starling/rendering/FilterEffect");}
function openfl__$Vector_VectorIterator() {return require("./../../openfl/_Vector/VectorIterator");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_ArgumentError() {return $import(require("openfl/errors/ArgumentError"));}
function starling_rendering_Program() {return require("./../../starling/rendering/Program");}
function starling_utils_RenderUtil() {return require("./../../starling/utils/RenderUtil");}
function starling_filters_CompositeMode() {return require("./../../starling/filters/CompositeMode");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}
function starling_utils_Color() {return require("./../../starling/utils/Color");}
function starling_filters_CompositeLayer() {return require("./../../starling/filters/CompositeLayer");}

// Constructor

var CompositeEffect = function(numLayers) {
	if(numLayers == null) {
		numLayers = 4;
	}
	(starling_rendering_FilterEffect().default).call(this);
	if(numLayers < 1 || numLayers > 4) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("number of layers must be between 1 and 4"));
	}
	this._layers = (openfl__$Vector_Vector_$Impl_$().default)._new(numLayers,true);
	var _g = 0;
	var _g1 = numLayers;
	while(_g < _g1) {
		var i = _g++;
		(openfl__$Vector_Vector_$Impl_$().default).set(this._layers,i,new (starling_filters_CompositeLayer().default)());
	}
}

// Meta

CompositeEffect.__name__ = "starling.filters.CompositeEffect";
CompositeEffect.__isInterface__ = false;
CompositeEffect.__super__ = (starling_rendering_FilterEffect().default);
CompositeEffect.prototype = $extend((starling_rendering_FilterEffect().default).prototype, {
	getLayerAt: function(layerID) {
		return this._layers[layerID];
	},
	getUsedLayers: function(out) {
		if(out == null) {
			out = [];
		} else {
			out.splice(0,out.length);
		}
		var layer = new (openfl__$Vector_VectorIterator().default)(this._layers);
		while(layer.hasNext()) {
			var layer1 = layer.next();
			if(layer1.texture != null) {
				out[out.length] = layer1;
			}
		}
		return out;
	},
	createProgram: function() {
		var layers = this.getUsedLayers(CompositeEffect.sLayers);
		var numLayers = layers.length;
		var i;
		if(numLayers != 0) {
			var vertexShader = ["m44 op, va0, vc0"];
			var layer = this._layers[0];
			var _g = 0;
			var _g1 = numLayers;
			while(_g < _g1) {
				var i1 = _g++;
				vertexShader.push("add v" + i1 + ", va" + (i1 + 1) + ", vc" + (i1 + 4));
			}
			var fragmentShader = ["sge ft5, v0, v0"];
			var _g2 = 0;
			var _g3 = numLayers;
			while(_g2 < _g3) {
				var i2 = _g2++;
				var fti = "ft" + i2;
				var fci = "fc" + i2;
				var vi = "v" + i2;
				layer = this._layers[i2];
				fragmentShader.push((starling_rendering_FilterEffect().default).tex(fti,vi,i2,layers[i2].texture));
				if(layer.replaceColor) {
					if(layer.invertAlpha) {
						fragmentShader.push("sub " + fti + ".w, ft5.w, " + fti + ".w");
					}
					fragmentShader.push("mul " + fti + ".w,   " + fti + ".w,   " + fci + ".w");
					fragmentShader.push("sat " + fti + ".w,   " + fti + ".w    ");
					fragmentShader.push("mul " + fti + ".xyz, " + fci + ".xyz, " + fti + ".www");
				} else {
					fragmentShader.push("mul " + fti + ", " + fti + ", " + fci);
				}
				if(i2 != 0) {
					switch(layer.mode) {
					case "inside":
						fragmentShader.push("mul ft4, ft0.wwww, " + fti);
						fragmentShader.push("sub ft6, ft5, " + fti + ".wwww");
						fragmentShader.push("mul ft6, ft6, ft0");
						fragmentShader.push("add ft0, ft6, ft4");
						break;
					case "insideKnockout":
						fragmentShader.push("mul ft0, ft0.wwww, " + fti);
						break;
					case "normal":
						fragmentShader.push("sub ft4, ft5, " + fti + ".wwww");
						fragmentShader.push("mul ft0, ft0, ft4");
						fragmentShader.push("add ft0, ft0, " + fti);
						break;
					case "outside":
						fragmentShader.push("sub ft4, ft5, ft0.wwww");
						fragmentShader.push("mul ft4, ft4, " + fti);
						fragmentShader.push("add ft0, ft0, ft4");
						break;
					case "outsideKnockout":
						fragmentShader.push("sub ft4, ft5, ft0.wwww");
						fragmentShader.push("mul ft0, ft4, " + fti);
						break;
					default:
						throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("Invalid composite mode: " + layer.mode));
					}
				}
			}
			fragmentShader.push("mov oc, ft0");
			return (starling_rendering_Program().default).fromSource(vertexShader.join("\n"),fragmentShader.join("\n"));
		} else {
			return (starling_rendering_FilterEffect().default).prototype.createProgram.call(this);
		}
	},
	get_programVariantName: function() {
		var bits;
		var modeBits;
		var textureBits;
		var invertAlphaBit;
		var replaceColorBit;
		var totalBits = 0;
		var layer;
		var layers = this.getUsedLayers(CompositeEffect.sLayers);
		var numLayers = layers.length;
		var _g = 0;
		var _g1 = numLayers;
		while(_g < _g1) {
			var i = _g++;
			layer = layers[i];
			textureBits = (starling_utils_RenderUtil().default).getTextureVariantBits(layer.texture);
			modeBits = (starling_filters_CompositeMode().default).getIndex(layer.mode);
			replaceColorBit = layer.replaceColor ? 1 : 0;
			invertAlphaBit = layer.invertAlpha ? 1 : 0;
			bits = textureBits | modeBits << 3 | replaceColorBit << 6 | invertAlphaBit << 7;
			totalBits = totalBits | bits << i * 8;
		}
		return totalBits;
	},
	beforeDraw: function(context) {
		(starling_rendering_FilterEffect().default).prototype.beforeDraw.call(this,context);
		var layers = this.getUsedLayers(CompositeEffect.sLayers);
		var numLayers = layers.length;
		if(numLayers != 0) {
			var _g = 0;
			var _g1 = numLayers;
			while(_g < _g1) {
				var i = _g++;
				var layer = layers[i];
				var texture = layer.texture;
				var alphaFactor = layer.replaceColor ? 1.0 : layer.alpha;
				(openfl__$Vector_Vector_$Impl_$().default).set(CompositeEffect.sOffset,0,-layer.x / (texture.get_root().get_nativeWidth() / texture.get_scale()));
				(openfl__$Vector_Vector_$Impl_$().default).set(CompositeEffect.sOffset,1,-layer.y / (texture.get_root().get_nativeHeight() / texture.get_scale()));
				(openfl__$Vector_Vector_$Impl_$().default).set(CompositeEffect.sColor,0,(starling_utils_Color().default).getRed(layer.color) * alphaFactor / 255.0);
				(openfl__$Vector_Vector_$Impl_$().default).set(CompositeEffect.sColor,1,(starling_utils_Color().default).getGreen(layer.color) * alphaFactor / 255.0);
				(openfl__$Vector_Vector_$Impl_$().default).set(CompositeEffect.sColor,2,(starling_utils_Color().default).getBlue(layer.color) * alphaFactor / 255.0);
				(openfl__$Vector_Vector_$Impl_$().default).set(CompositeEffect.sColor,3,layer.alpha);
				context.setProgramConstantsFromVector("vertex",i + 4,CompositeEffect.sOffset);
				context.setProgramConstantsFromVector("fragment",i,CompositeEffect.sColor);
				if(i > 0) {
					context.setTextureAt(i,texture.get_base());
					(starling_utils_RenderUtil().default).setSamplerStateAt(i,texture.get_mipMapping(),this.get_textureSmoothing());
					this.get_vertexFormat().setVertexBufferAt(i + 1,this.get_vertexBuffer(),"texCoords" + i);
				}
			}
		}
	},
	afterDraw: function(context) {
		var layers = this.getUsedLayers(CompositeEffect.sLayers);
		var numLayers = layers.length;
		var _g = 1;
		var _g1 = numLayers;
		while(_g < _g1) {
			var i = _g++;
			context.setTextureAt(i,null);
			context.setVertexBufferAt(i + 1,null);
		}
		(starling_rendering_FilterEffect().default).prototype.afterDraw.call(this,context);
	},
	get_vertexFormat: function() {
		return CompositeEffect.VERTEX_FORMAT;
	},
	get_numLayers: function() {
		return this._layers.length;
	},
	set_texture: function(value) {
		this._layers[0].texture = value;
		(starling_rendering_FilterEffect().default).prototype.set_texture.call(this,value);
		return value;
	}
});
CompositeEffect.prototype.__class__ = CompositeEffect.prototype.constructor = $hxClasses["starling.filters.CompositeEffect"] = CompositeEffect;

// Init



// Statics


CompositeEffect.VERTEX_FORMAT = (starling_rendering_FilterEffect().default).VERTEX_FORMAT.extend("texCoords1:float2, texCoords2:float2, texCoords3:float2")
CompositeEffect.sLayers = []
CompositeEffect.sOffset = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0.])
CompositeEffect.sColor = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0.])

// Export

exports.default = CompositeEffect;